var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#send_28-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.076 11.887 8.328 2.869c-1.661-.894-2.492-1.342-3.04-1.218a1.5 1.5 0 0 0-1.054.887c-.215.518.083 1.413.68 3.203l.975 2.926c.406 1.217.609 1.826.963 2.319a4 4 0 0 0 1.17 1.084c.52.315 1.142.471 2.386.782l1.488.372c.911.228 1.367.342 1.474.523a.5.5 0 0 1 0 .506c-.106.181-.563.295-1.474.523l-1.488.372c-1.244.311-1.867.467-2.385.782a4 4 0 0 0-1.171 1.084c-.354.493-.557 1.102-.963 2.32l-.975 2.925c-.597 1.79-.895 2.685-.68 3.203.187.45.58.78 1.055.887.547.124 1.378-.323 3.04-1.218l16.747-9.018c1.276-.687 1.913-1.03 2.123-1.487a1.5 1.5 0 0 0 0-1.252c-.21-.457-.848-.8-2.123-1.487Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "send_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend28);
export default __webpack_public_path__ + "static/media/send_28.0e15c3f1.svg";
export { ForwardRef as ReactComponent };